import { Report, SideFilter, Value } from './ReportContext'

const sideFilters: SideFilter[] = [
  {
    id: 'case_type',
    displayName: 'Case Type',
    source: 'master',
    values: [
      {
        id: 'Internal Processing',
        value: 'Internal Processing',
        label: 'Internal Processing',
        isChecked: false,
      },
      {
        id: 'Dispute',
        value: 'Dispute',
        label: 'Dispute',
        isChecked: false,
      },
      {
        id: 'Request a Copy/Info',
        value: 'Request a Copy/Info',
        label: 'Request a Copy/Info',
        isChecked: false,
      },
    ],
    type: 'checkbox',
  },
  {
    id: 'workflow',
    displayName: 'Workflows',
    source: 'master',
    values: [],
    type: 'checkbox',
  },
  {
    id: 'status',
    displayName: 'Status',
    source: 'master',
    values: [
      {
        id: 'New',
        value: 'New',
        label: 'New',
      },
      {
        id: 'InProgress',
        value: 'InProgress',
        label: 'In Progress',
      },
      {
        id: 'ReOpen',
        value: 'ReOpen',
        label: 'Re Opened',
      },
      {
        id: 'AwaitingInfo',
        value: 'AwaitingInfo',
        label: 'Awaiting Info',
      },
    ],
    type: 'radio',
  },
]

const dateFilters: Value[] = [
  {
    id: '7d',
    label: 'Last 7 days',
    value: {
      from: 'now-7d',
      to: 'now',
    },
  },
  {
    id: '30d',
    label: 'Last 30 Days',
    value: {
      from: 'now-30d',
      to: 'now',
    },
  },
  {
    id: '360d',
    label: 'Last 1 Year',
    value: {
      from: 'now-365d',
      to: 'now',
    },
  },
]

export const workflowManagement: Report[] = [
  {
    id: 'New',
    reportName: 'Aging of New cases',
    sideFilters: [...sideFilters],
    ageingWindow: '15,25,30,60,90',
    ageingField: 'current_date',
    dateFilter: {
      id: 'create_timestamp',
      options: dateFilters,
      active: {
        from: 'now-365d',
        to: 'now',
      },
    },
  },
  {
    id: 'InProgress',
    reportName: 'Aging of In Progress cases',
    sideFilters: [...sideFilters],
    ageingWindow: '15,25,30,60,90',
    ageingField: 'current_date',
    dateFilter: {
      id: 'create_timestamp',
      options: dateFilters,
      active: {
        from: 'now-365d',
        to: 'now',
      },
    },
  },
  {
    id: 'ReOpen',
    reportName: 'Aging of Re Opened cases',
    sideFilters: [...sideFilters],
    ageingWindow: '15,25,30,60,90',
    ageingField: 'current_date',
    dateFilter: {
      id: 'create_timestamp',
      options: dateFilters,
      active: {
        from: 'now-365d',
        to: 'now',
      },
    },
  },
  {
    id: 'AwaitingInfo',
    reportName: 'Aging of Awaiting Info cases',
    sideFilters: [...sideFilters],
    ageingWindow: '1,3,5',
    ageingField: 'update_to_date',
    dateFilter: {
      id: 'create_timestamp',
      options: dateFilters,
      active: {
        from: 'now-365d',
        to: 'now',
      },
    },
  },
]
